import {v4 as uuidv4} from 'uuid';

export default class {
  static generate() {
    return uuidv4();
  }

  // Probability that an uuid has exactly this value = 1 to 10^37
  static noResponseUuid() {
    return '00000000-0000-0000-0000-000000000000';
  }

  static isUuidV4(valueToCheck) {
    const uuidV4Regex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidV4Regex.test(valueToCheck);
  }
}
